import React from 'react';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { CalendarRange } from 'lucide-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './daterangepicker.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setDateRange } from '../../../redux/actions/dateTimeActions';


const CustomInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
  <input
    className={styles.dateRangePickerInput}
    onClick={onClick}
    value={value}
    placeholder={placeholder}
    ref={ref}
    readOnly 
  />
));

const CustomDaterangepicker = () => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useSelector((state) => state.dateTime.dateRange);

  // Local state to track UI selections
  const [localDates, setLocalDates] = useState([
    startDate ? dayjs(startDate, 'YYYY-MM-DD').toDate() : null,
    endDate ? dayjs(endDate, 'YYYY-MM-DD').toDate() : null,
  ]);

  // Sync local state when Redux date changes (external reset, reload, etc.)
  useEffect(() => {
    setLocalDates([
      startDate ? dayjs(startDate, 'YYYY-MM-DD').toDate() : null,
      endDate ? dayjs(endDate, 'YYYY-MM-DD').toDate() : null,
    ]);
  }, [startDate, endDate]);

  const handleDateChange = (dates) => {
    setLocalDates(dates);

    const [start, end] = dates;
    if (start && end) {
      const payload = {
        startDate: dayjs(start).format('YYYY-MM-DD'),
        endDate: dayjs(end).format('YYYY-MM-DD'),
      };
      dispatch(setDateRange(payload));
    }
  };

  return (
    <div className={styles.dateInputWrapper}>
      <CalendarRange className={styles.calendarIcon} />
      <DatePicker
        selectsRange
        startDate={localDates[0]}
        endDate={localDates[1]}
        onChange={handleDateChange}
        dateFormat="MMMM d, yyyy"
        placeholderText="Select date range"
        customInput={<CustomInput />}
        shouldCloseOnSelect={false}
        maxDate={new Date()}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        isClearable={false}
      />
    </div>
  );
};

export default CustomDaterangepicker;
